import WithRender from "../../templates/buttons/addToCartButton.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";
import * as R from "ramda";

export default WithRender({
  computed: {
    ...mapGetters([
      "getAddToCartCallbacks",
      "getOnCartSubmitCallback",
      "getHasAutomaticConnect",
      "getFilesConnectLoading",
      "getNumberOfActiveUploads",
      "getIsChangeOptionsLoading",
      "getIsValidForm",
      "getChangeOptionsPostData",
      "getQuantity",
      "getCallChangeOptionPerType",
      "getQuantityField",
      "getChangeOptionsData",
      "getShowAddToCart",
      "getQuantity",
      "getIsLfp",
      "getCimpressPricesFailed",
      "getIsCimpressSelectionResolved"
    ]),
    getDisableClass: function () {
      if (this.getCimpressPricesFailed) {
        return "disabled";
      }
      return this.getIsChangeOptionsLoading ||
        this.getFilesConnectLoading ||
        !this.getIsCimpressSelectionResolved ||
        this.getNumberOfActiveUploads > 0
        ? "disabled"
        : "";
    }
  },
  methods: {
    ...mapActions(["setQuantityField", "completePersonalization"]),
    onClickAddToCart: function (event) {
      var valid = this.validate();
      if (!valid) {
        return;
      }
      if (this.getAddToCartCallbacks) {
        R.forEach(callback => {
          if (typeof callback === "function") callback(event);
        }, this.getAddToCartCallbacks);
      }

      var qty = this.getChangeOptionsData.qty;
      if (qty == undefined) {
        // happens for personlization when opened in iframe
        qty = this.getQuantity;
      }
      if (!qty) {
        qty = 1;
        this.setQuantityField(qty);
        return;
      }

      var onCartData = this.getChangeOptionsPostData(false);
      if (!this.getCallChangeOptionPerType) {
        onCartData.qty = qty;
      }
      if (this.getIsLfp) {
        var payload = {
          onCartDataEncoded: btoa(JSON.stringify(onCartData)),
          onCartData: onCartData,
          callbackFucntion: this.getOnCartSubmitCallback
        };
        this.completePersonalization(payload);
      } else {
        this.getOnCartSubmitCallback(onCartData);
      }
    },

    validate: function () {
      return this.getIsValidForm(this);
    }
  }
});
